// extracted by mini-css-extract-plugin
module.exports = {"list":"DualColumns_list__2R1NU","column":"DualColumns_column___-BlY"};